import { useCallback, useState } from 'react'

export function useDetectOverflow<T extends HTMLDivElement>(): [overflow: boolean, ref: (node: T | null) => void] {
  const [overflow, setOverflow] = useState(false)
  const ref = useCallback((node: T | null) => {
    if (node) setOverflow(node.offsetWidth !== node.scrollWidth)
  }, [])

  return [overflow, ref] as const
}
